import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import InspectionPhotoGrid, { PhotoViewer } from '../InspectionPhotoGrid/InspectionPhotoGrid';
import GeneralStateSelector from '../GeneralStateSelector/GeneralStateSelector';
import MileageInput from '../MileageInput/MileageInput';
import FuelLevelSelector from '../FuelLevelSelector/FuelLevelSelector';
import ChecklistSection from '../ChecklistSection/ChecklistSection';
import s from '../Inspection.css';

// Read-only content of a check-in or a check-out (recap of the other party, locked record, admin consultation).
export function InspectionDetails({ inspection, type, checklistItems, max }) {
  const { formatMessage } = useIntl();
  const [viewer, setViewer] = useState(-1);
  if (!inspection) return null;
  const photos = (inspection.photos || []).map((photo) => ({ ...photo, status: 'ready' }));
  const isCheckin = type === 'checkin';
  return (
    <div>
      <section className={s.card}>
        <h3 className={s.cardTitle}><span className={s.step} aria-hidden="true">1</span>{formatMessage(isCheckin ? messages.inspPhotosVehicle : messages.inspPhotosDamage)}</h3>
        {photos.length === 0
          ? <p className={s.cardHint}>{formatMessage(messages.inspNoPhotos)}</p>
          : <InspectionPhotoGrid items={photos} max={max || photos.length} editable={false} onViewAll={() => setViewer(0)} title={formatMessage(messages.inspPhotosVehicle)} />}
        {viewer >= 0 && <PhotoViewer photos={photos} index={viewer} onIndex={setViewer} onClose={() => setViewer(-1)} />}
      </section>
      {isCheckin ? (
        <section className={s.card}>
          <h3 className={s.cardTitle}><span className={s.step} aria-hidden="true">2</span>{formatMessage(messages.inspGeneralStateTitle)}</h3>
          <GeneralStateSelector value={inspection.generalState || ''} disabled />
        </section>
      ) : (
        <section className={s.card}>
          <h3 className={s.cardTitle}>{formatMessage(messages.inspDamageDescriptionTitle)}</h3>
          <p className={s.statementBody}>{inspection.hasDamage ? (inspection.damageDescription || '-') : formatMessage(messages.inspNoDamageDeclared)}</p>
        </section>
      )}
      <div className={s.grid2}>
        <section className={s.card}>
          <h3 className={s.cardTitle}>{formatMessage(messages.inspMileageTitle)}</h3>
          <MileageInput value={inspection.mileage === null || inspection.mileage === undefined ? '' : inspection.mileage} disabled />
        </section>
        <section className={s.card}>
          <h3 className={s.cardTitle}>{formatMessage(messages.inspFuelTitle)}</h3>
          <FuelLevelSelector value={inspection.fuelLevel || ''} disabled />
        </section>
      </div>
      {isCheckin && (
        <section className={s.card}>
          <h3 className={s.cardTitle}>{formatMessage(messages.inspChecklistTitle)}</h3>
          <ChecklistSection items={checklistItems && checklistItems.length ? checklistItems : (inspection.checklist || []).map((row) => ({ key: row.key }))} answers={inspection.checklist} disabled />
        </section>
      )}
      <section className={s.card}>
        <h3 className={s.cardTitle}>{formatMessage(messages.inspKeysTitle)}</h3>
        <p className={s.readOnlyValue}>{formatMessage(inspection.keysConfirmed ? messages.inspYes : messages.inspNo)}</p>
      </section>
      <section className={s.card}>
        <h3 className={s.cardTitle}>{formatMessage(messages.inspCommentTitle)}</h3>
        <p className={s.statementBody}>{inspection.comment || '-'}</p>
      </section>
    </div>
  );
}

InspectionDetails.propTypes = {
  inspection: PropTypes.object,
  type: PropTypes.string.isRequired,
  checklistItems: PropTypes.array,
  max: PropTypes.number
};

export default withStyles(s)(InspectionDetails);
